import {Sprite} from 'pixi.js';
import {InstrumentButtons} from './draw_menu/InstrumentButtons';
import {InstrumentTopBlock} from './draw_menu/InstrumentTopBlock';
import {DrawInstrumentMenuData} from './draw_menu/draw_buttons/DrawInstrumentMenuData';
import {DrawHolderEvent} from './draw_menu/events/DrawHolderEvent';

export class DrawMenu extends Sprite
{
    public instrumentButtons: InstrumentButtons;
    public instrumentTopBlock: InstrumentTopBlock;

    constructor(instrumentsData: DrawInstrumentMenuData[]) {
        super();

        this.instrumentTopBlock = new InstrumentTopBlock();
        this.instrumentButtons = new InstrumentButtons(this.onInstrumentClick.bind(this), instrumentsData);

        this.addChild(this.instrumentButtons);
        this.addChild(this.instrumentTopBlock).y = -57;
    }

    private async onInstrumentClick(instrument: DrawInstrumentMenuData): Promise<void> {
        await this.instrumentTopBlock.setInstrument(instrument);
        dispatchEvent(new MessageEvent(DrawHolderEvent.SELECT_INSTRUMENT, {data: {instrument}}));
    }
}
